let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("04NrR")).then(() => parcelRequire('UK5pP'));